export class ListaDeAcuerdos {
  constructor(
    listaDeAcuerdosId = 0,
    fechaDeDictado = null,
    fechaDePublicacion = null,
    rutaArchivo = null,
    usuarioCreadorId = null,
    fechaDeCreacion = null,
    activo = null,
    listaDeAcuerdosPadreId = null,
    listasDeAcuerdosAnexas = null,
    listasDeAcuerdosPadre = null,
    acuerdos = null
  ) {
    this.listaDeAcuerdosId = listaDeAcuerdosId;
    this.fechaDeDictado = fechaDeDictado;
    this.fechaDePublicacion = fechaDePublicacion;
    this.rutaArchivo = rutaArchivo;
    this.usuarioCreadorId = usuarioCreadorId;
    this.fechaDeCreacion = fechaDeCreacion;
    this.activo = activo;
    this.listaDeAcuerdosPadreId = listaDeAcuerdosPadreId;
    this.listasDeAcuerdosAnexas = listasDeAcuerdosAnexas;
    this.listasDeAcuerdosPadre = listasDeAcuerdosPadre;
    this.acuerdos = acuerdos;
  }
  constructorObjeto(acuerdoObject) {
    this.listaDeAcuerdosId = acuerdoObject.listaDeAcuerdosId;
    this.fechaDeDictado = acuerdoObject.fechaDeDictado;
    this.fechaDePublicacion = acuerdoObject.fechaDePublicacion;
    this.rutaArchivo = acuerdoObject.rutaArchivo;
    this.usuarioCreadorId = acuerdoObject.usuarioCreadorId;
    this.fechaDeCreacion = acuerdoObject.fechaDeCreacion;
    this.activo = acuerdoObject.activo;
    this.listaDeAcuerdosPadreId = acuerdoObject.listaDeAcuerdosPadreId;
    this.listasDeAcuerdosAnexas = acuerdoObject.listasDeAcuerdosAnexas;
    this.listasDeAcuerdosPadre = acuerdoObject.listasDeAcuerdosPadre;
    this.acuerdos = acuerdoObject.Acuerdos;
  }
  cargarDatosParaFormulario(args) {
    if (args.includes("insertar-lista-de-acuerdos")) {
      this.activo = true;
      this.rutaArchivo = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SIFA/Comun/Modelos/ListaDeAcuerdos.js